export default {
    defaultWfpTitle: "Digital Assistant",
    defaultChatTitle: "Chat with operator",
    defaultWfpHeaderPrivacy: 'The conversation will be saved for quality purposes. For more details, see the <a href="https://www.wfp.it/privacy/" target="_blank">privacy</a> section',
    defaultPrivacyMessage: `
    Hello,
    <br />
    please be informed that this chat uses an artificial intelligence system, in some cases generative, to respond accurately, quickly, and efficiently to your requests. Privacy notice at <a href="https://www.wfp.it/wfp-chat-privacy/" target="_blank">this link</a>.
    <br /><br />
    Additionally, to provide you with a personalized service and more effective responses via chatbot, do you authorize the processing of data provided within this conversation session?
  `,
    defaultWfpWelcomeMessage: `Welcome, dear colleague, I’m your digital assistant here to support you with UNHRD service requests - including procurement, transport and warehousing service.
    How can I help you today?`,
    defaultTimeoutMessage: "Dear colleague, your conversation has been inactive for a while. Would you like to continue where you left or start a new question?",
    defaultConversationListHeading: "CONVERSATION LIST",
    defaultCasesHistoryHeading: "CASES HISTORY",
    defaultBackToConversationListLabel: "CHAT",
    defaultAskBotLabel: "Ask",
    defaultXmppConnectionMessage: "Thanks for your patience — the chat is loading and will be ready shortly. <br/> For the best experience, make sure the chatbot is open in just one browser window.",
    defaultSelectButtonLabel: "Select first a button to carry on",
    defaultInputTextPlaceholder: "Write your message",
    defaultInputDatePlaceholder: "Insert date",
    defaultInputLocationPlaceholder: "Insert location",
    defaultInputAutocompletePlaceholder: "Search choices",
    defaultPopupLocationPlaceholder: "write a position",
    defaultPopupButtonCancel: "Cancel",
    defaultPopupButtonConfirm: "Confirm",
    defaultTimeoutContinuePreviousMessage: "Continue",
    defaultTimeoutRestartMessage: "Start a new question",
    defaultRestartMessage: "New question",
    xmppErrorDefault: "Error during XMPP authentication",
    attachmentsErrorDefault: "An error occurred while uploading the file",
    attachmentsErrorNotFound: "No attachment was selected",
    attachmentsErrorExtensionNotAllowed: "The extension of the selected attachment is not supported (.jpg, .png, .gif, .tif, .doc, .docx, .pdf, .mp3, .zip, .rar)",
    attachmentsErrorFileTooBig: "The selected attachment is too large",
    attachmentsErrorInvalidConversation: "This is not a valid conversation for sending the selected attachment",
};
